/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Tableheaders_Creationdate2Inputs */

const id_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Pembuatan`)
};

const ms_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Penciptaan`)
};

const da_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oprettelsesdato`)
};

const de_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellungsdatum`)
};

const en_us2_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creation Date`)
};

const es_es2_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const es_mx2_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

const fil_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng Paggawa`)
};

const fr_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de création`)
};

const it_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di creazione`)
};

const hu_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Létrehozás dátuma`)
};

const nl_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanmaakdatum`)
};

const no_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprettelsesdato`)
};

const pl_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data utworzenia`)
};

const pt_br2_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const pt_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de criação`)
};

const ro_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data creării`)
};

const fi_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luontipäivä`)
};

const sv_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapelsedatum`)
};

const vi_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày tạo`)
};

const tr_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oluşturulma Tarihi`)
};

const cs_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vytvoření`)
};

const bg_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на създаване`)
};

const ru_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата создания`)
};

const uk_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата створення`)
};

const ar_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الإنشاء`)
};

const hi_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्माण तिथि`)
};

const th_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่สร้าง`)
};

const ja_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日`)
};

const zh_cn2_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建日期`)
};

const zh_hant1_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`建立日期`)
};

const ko_home_tableheaders_creationdate2 = /** @type {(inputs: Home_Tableheaders_Creationdate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 날짜`)
};

/**
* | output |
* | --- |
* | "Creation Date" |
*
* @param {Home_Tableheaders_Creationdate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_tableheaders_creationdate2 = /** @type {((inputs?: Home_Tableheaders_Creationdate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Tableheaders_Creationdate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_tableheaders_creationdate2(inputs)
	if (locale === "ms") return ms_home_tableheaders_creationdate2(inputs)
	if (locale === "da") return da_home_tableheaders_creationdate2(inputs)
	if (locale === "de") return de_home_tableheaders_creationdate2(inputs)
	if (locale === "en-US") return en_us2_home_tableheaders_creationdate2(inputs)
	if (locale === "es-ES") return es_es2_home_tableheaders_creationdate2(inputs)
	if (locale === "es-MX") return es_mx2_home_tableheaders_creationdate2(inputs)
	if (locale === "fil") return fil_home_tableheaders_creationdate2(inputs)
	if (locale === "fr") return fr_home_tableheaders_creationdate2(inputs)
	if (locale === "it") return it_home_tableheaders_creationdate2(inputs)
	if (locale === "hu") return hu_home_tableheaders_creationdate2(inputs)
	if (locale === "nl") return nl_home_tableheaders_creationdate2(inputs)
	if (locale === "no") return no_home_tableheaders_creationdate2(inputs)
	if (locale === "pl") return pl_home_tableheaders_creationdate2(inputs)
	if (locale === "pt-BR") return pt_br2_home_tableheaders_creationdate2(inputs)
	if (locale === "pt") return pt_home_tableheaders_creationdate2(inputs)
	if (locale === "ro") return ro_home_tableheaders_creationdate2(inputs)
	if (locale === "fi") return fi_home_tableheaders_creationdate2(inputs)
	if (locale === "sv") return sv_home_tableheaders_creationdate2(inputs)
	if (locale === "vi") return vi_home_tableheaders_creationdate2(inputs)
	if (locale === "tr") return tr_home_tableheaders_creationdate2(inputs)
	if (locale === "cs") return cs_home_tableheaders_creationdate2(inputs)
	if (locale === "bg") return bg_home_tableheaders_creationdate2(inputs)
	if (locale === "ru") return ru_home_tableheaders_creationdate2(inputs)
	if (locale === "uk") return uk_home_tableheaders_creationdate2(inputs)
	if (locale === "ar") return ar_home_tableheaders_creationdate2(inputs)
	if (locale === "hi") return hi_home_tableheaders_creationdate2(inputs)
	if (locale === "th") return th_home_tableheaders_creationdate2(inputs)
	if (locale === "ja") return ja_home_tableheaders_creationdate2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_tableheaders_creationdate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_tableheaders_creationdate2(inputs)
	return ko_home_tableheaders_creationdate2(inputs)
});
export { home_tableheaders_creationdate2 as "home.tableHeaders.creationDate" }